/**
 * Adds or updates query parameters in a URL string
 * @param {string} urlString - The URL to modify (can be absolute or relative)
 * @param {Record<string, string>} params - Object with key-value pairs to add/update
 * @returns {string} The modified URL with updated query parameters
 */
const addUrlQueryParams = (urlString, params) => {
  if (!urlString || typeof urlString !== "string") {
    return urlString;
  }

  if (!params || Object.keys(params).length === 0) {
    return urlString;
  }

  try {
    const isAbsolute = /^https?:\/\//.test(urlString);

    const url = isAbsolute ? new URL(urlString) : new URL(urlString, window.location.origin);

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        url.searchParams.set(key, String(value));
      }
    });

    if (isAbsolute) return url.toString();

    const relativePath = url.pathname + url.search + url.hash;
    return urlString.startsWith("/") ? relativePath : relativePath.replace(/^\//, "");
  } catch (error) {
    console.warn("Failed to parse URL:", urlString, error);
    return urlString;
  }
};

export default addUrlQueryParams;
